import styled from 'styled-components';

export const SignUp = styled.div`
  display: block;
  padding: 14% 10%;
  background-color: ${(props) => props.theme.color.primary};
  color: ${(props) => props.theme.color.white};
  a {
    width: 92%;
    padding: 13px 0;
    border: 1px solid ${(props) => props.theme.color.white};
    border-radius: 4px;
    display: inline-block;
    background-color: ${(props) => props.theme.color.white};
    color: ${(props) => props.theme.color.bgPrimary};
    font-size: 16px;
    ${(props) => props.theme.fontStyleMedium}
    text-transform: capitalize;
    transition: background-color ease-in-out 0.2s, color ease-in-out 0.2s;
    @media (min-width: 1024px) {
      &:hover {
        background-color: ${(props) => props.theme.color.bgPrimary};
        color: ${(props) => props.theme.color.white};
      }
    }
  }
  text-align: center;
  @media (max-width: 995px) {
    padding: 12% 8%;
    button {
      width: 60%;
    }
  }
  @media (max-width: 576px) {
    button {
      width: 80%;
    }
  }
`;

export const SignUpTitle = styled.span`
  margin-bottom: 15px;
  display: block;
  ${(props) => props.theme.fontStyleMedium}
  font-size: 32px;
  line-height: 48px;
  @media (max-width: 768px) {
    font-size: 22px;
    line-height: 33px;
  }
`;
